export const PAYROLL_FETCH_RESOURCE_REQUEST = "PAYROLL_FETCH_RESOURCE_REQUEST";
export const PAYROLL_FETCH_RESOURCE_SUCCESS = "PAYROLL_FETCH_RESOURCE_SUCCESS";
export const PAYROLL_FETCH_RESOURCE_FAIL = "PAYROLL_FETCH_RESOURCE_FAIL";

export const PAYROLL_SAVE_RESOURCE_REQUEST = "PAYROLL_SAVE_RESOURCE_REQUEST";
export const PAYROLL_SAVE_RESOURCE_SUCCESS = "PAYROLL_SAVE_RESOURCE_SUCCESS";
export const PAYROLL_SAVE_RESOURCE_FAIL = "PAYROLL_SAVE_RESOURCE_FAIL";

export const PAYROLL_DELETE_RESOURCE_REQUEST = "PAYROLL_DELETE_RESOURCE_REQUEST";
export const PAYROLL_DELETE_RESOURCE_SUCCESS = "PAYROLL_DELETE_RESOURCE_SUCCESS";
export const PAYROLL_DELETE_RESOURCE_FAIL = "PAYROLL_DELETE_RESOURCE_FAIL";

export const PAYROLL_CALCULATE_BULLETIN_REQUEST = "PAYROLL_CALCULATE_BULLETIN_REQUEST";
export const PAYROLL_CALCULATE_BULLETIN_SUCCESS = "PAYROLL_CALCULATE_BULLETIN_SUCCESS";
export const PAYROLL_CALCULATE_BULLETIN_FAIL = "PAYROLL_CALCULATE_BULLETIN_FAIL";

export const PAYROLL_FETCH_BULLETIN_LINES_REQUEST = "PAYROLL_FETCH_BULLETIN_LINES_REQUEST";
export const PAYROLL_FETCH_BULLETIN_LINES_SUCCESS = "PAYROLL_FETCH_BULLETIN_LINES_SUCCESS";
export const PAYROLL_FETCH_BULLETIN_LINES_FAIL = "PAYROLL_FETCH_BULLETIN_LINES_FAIL";

export const PAYROLL_CLEAR_ERROR = "PAYROLL_CLEAR_ERROR";

export const payrollFetchResourceRequest = (resource, params = {}) => ({
    type: PAYROLL_FETCH_RESOURCE_REQUEST,
    payload: { resource, params },
});

export const payrollFetchResourceSuccess = (resource, data) => ({
    type: PAYROLL_FETCH_RESOURCE_SUCCESS,
    payload: { resource, data },
});

export const payrollFetchResourceFail = (resource, error) => ({
    type: PAYROLL_FETCH_RESOURCE_FAIL,
    payload: { resource, error },
});

export const payrollSaveResourceRequest = (resource, data, id = null) => ({
    type: PAYROLL_SAVE_RESOURCE_REQUEST,
    payload: { resource, data, id },
});

export const payrollSaveResourceSuccess = (resource, data) => ({
    type: PAYROLL_SAVE_RESOURCE_SUCCESS,
    payload: { resource, data },
});

export const payrollSaveResourceFail = (resource, error) => ({
    type: PAYROLL_SAVE_RESOURCE_FAIL,
    payload: { resource, error },
});

export const payrollDeleteResourceRequest = (resource, id) => ({
    type: PAYROLL_DELETE_RESOURCE_REQUEST,
    payload: { resource, id },
});

export const payrollDeleteResourceSuccess = (resource, id) => ({
    type: PAYROLL_DELETE_RESOURCE_SUCCESS,
    payload: { resource, id },
});

export const payrollDeleteResourceFail = (resource, error) => ({
    type: PAYROLL_DELETE_RESOURCE_FAIL,
    payload: { resource, error },
});

export const payrollCalculateBulletinRequest = (data) => ({
    type: PAYROLL_CALCULATE_BULLETIN_REQUEST,
    payload: data,
});

export const payrollCalculateBulletinSuccess = (data) => ({
    type: PAYROLL_CALCULATE_BULLETIN_SUCCESS,
    payload: data,
});

export const payrollCalculateBulletinFail = (error) => ({
    type: PAYROLL_CALCULATE_BULLETIN_FAIL,
    payload: error,
});

export const payrollFetchBulletinLinesRequest = (bulletinId) => ({
    type: PAYROLL_FETCH_BULLETIN_LINES_REQUEST,
    payload: { bulletinId },
});

export const payrollFetchBulletinLinesSuccess = (bulletinId, data) => ({
    type: PAYROLL_FETCH_BULLETIN_LINES_SUCCESS,
    payload: { bulletinId, data },
});

export const payrollFetchBulletinLinesFail = (error) => ({
    type: PAYROLL_FETCH_BULLETIN_LINES_FAIL,
    payload: error,
});

export const payrollClearError = () => ({ type: PAYROLL_CLEAR_ERROR });
